import { render, staticRenderFns } from "./VehicleEntity.vue?vue&type=template&id=1d27e6e5&"
import script from "./VehicleEntity.vue?vue&type=script&lang=js&"
export * from "./VehicleEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d27e6e5')) {
      api.createRecord('1d27e6e5', component.options)
    } else {
      api.reload('1d27e6e5', component.options)
    }
    module.hot.accept("./VehicleEntity.vue?vue&type=template&id=1d27e6e5&", function () {
      api.rerender('1d27e6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VehicleEntity.vue"
export default component.exports